import React, { FunctionComponent } from 'react';
import config from '@app/config';

// Import with proper typing
import { LoadScript } from '@react-google-maps/api';

interface ConditionalGoogleMapsProviderProps {
  children: React.ReactNode;
}

const ConditionalGoogleMapsProvider: FunctionComponent<ConditionalGoogleMapsProviderProps> = ({ children }) => {
  // Only load Google Maps script for supplierRegistration mode
  if (config.mode === 'supplierRegistration') {
    return (
      <LoadScript googleMapsApiKey={config.googleMapsApiKey || ''} libraries={['places']}>
        {children}
      </LoadScript>
    );
  }

  // For other modes, render children without Google Maps script
  return <>{children}</>;
};

export default ConditionalGoogleMapsProvider;
